import React from 'react';
import { Col, FormControl, FormGroup, Button } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead'; // <Select> di HTML5 con autocompletamento
// css
import 'react-bootstrap-typeahead/css/Typeahead.css';
import '../../../styles/commonStyles.css';

class Prodotto extends React.Component { 

  constructor(props) {
    super(props);    

    const { lastProduct, editMode, panProdotti, pos } = this.props;     

    let defaultCodArticle = (lastProduct!==null)? lastProduct['codArt'] : '';
    let defaultDescription = (lastProduct!==null)? lastProduct['description'] : '';
    let defaultNote = (lastProduct!==null)? lastProduct['note'] : '';       
    let defaultFuoriMisura = (lastProduct!==null)? parseFloat(lastProduct['fuoriMisura']) : 0; 
    // Lascio come default il peso obbligatorio, onChange dell'articolo cambia anche questo valore
    let defaultSubGruppo = (lastProduct!==null)? lastProduct['subGruppo'] : "M";            

    let codes = [];           
    
    for(let i=0; i<this.props.articles[0].length; i++) {
      // articles[0] => {[art1], ..., [artN]}
	  	// art = {Key:Value} 
      let article = this.props.articles[0][i];                      

      // Estrae i Value di ogni oggetto (ignora Key)        
      let values = Object.values(article);	                
      
      if (editMode) {          
        // Dal momento che non viene salvato il valore di subGruppo, in caso di edit mode,
        // lo recupera da articles che contiene le info sugli articoli (tra cui subGruppo).
        // Non serve in caso di inserimento poiche' acquisisce subGruppo onChange() dell'articolo
        if (panProdotti['codArt_'+pos] == values[1].toString()) {
          panProdotti['subGruppo_'+pos] = values[4] == null? '' : values[4].toString();            
        }
      }

      // codes (copiandolo nello state) popolerà <Typeahead />,
      // a video il componente mostra il valore della key 'label'
	    codes.push({
	    	'id': values[0].toString(), 
	    	'label': values[1].toString(),
        'descrizione': values[2].toString(),
        'fuoriMisura': parseFloat(values[3]),
        'subGruppo': values[4] == null? '' : values[4].toString()        
	    });
    }
	  
	  // Se non ci sono articoli nel database,
	  // ritorna un'opzione vuota (se selezionata invalida il form)	  
	  if (codes.length === 0) 
	  	codes.push("");
    
    if (editMode) {
      // Deve usare il valore di default dei campi se panProdotti non è definito (nuovo ordine)
      // oppure se è stato aggiunto un nuovo articolo vuoto (panProdotti[i] soltanto inizializzato)
      let panDef = !(typeof panProdotti == "undefined") && (panProdotti['codArt_'+(pos)] > '');      

      this.state = {  
        editMode,       
        options: codes, 
        codArticle: (panDef)? panProdotti['codArt_'+(pos)] : defaultCodArticle,      
        description: (panDef)? panProdotti['descArt_'+(pos)] : defaultDescription,    
        note: (panDef)? panProdotti['noteArt_'+(pos)] : defaultNote,  
        peso: (panDef)? parseFloat(panProdotti['pesoArt_'+(pos)]) : '',
        fuoriMisura: (panDef)? parseFloat(panProdotti['dimArt_'+(pos)]) : defaultFuoriMisura, 
        subGruppo: (panDef)? panProdotti['subGruppo_'+(pos)] : defaultSubGruppo      
      }       
    } else {
      this.state = {  
        editMode,       
        options: codes, 
        codArticle: defaultCodArticle,      
        description: defaultDescription,    
        note: defaultNote,  
        peso: '',
        fuoriMisura: defaultFuoriMisura, 
        subGruppo: defaultSubGruppo      
      } 
    }                         

    this.askPesoRef = React.createRef();
    this.handleLast = this.handleLast.bind(this);
  }

  render() {
    const { pos, remove, nrOfProducts } = this.props;
    const { options, codArticle, description, fuoriMisura, subGruppo } = this.state;    
    
    return (      
    	<div>        
      	<Col xs={12} hidden>          
          <FormControl 
            id={"codArt_"+pos} name={"codArt_"+pos}	  
            type="text" value={codArticle} onChange={()=>{console.log("")}}
            data-caption={"Codice articolo ("+pos+")"}           
            required 
          />	  
        </Col>        

        <Col xs={12} lg={2}>
          <label htmlFor={"codArt_"+pos}>Codice articolo</label>          	
					<Typeahead
            id={pos}
						options={options} // Contiene le voci della select
            defaultInputValue={codArticle}
            onChange={(selected) => {
            	// Selected[0] è undefined quando nessuna option è selezionata,
            	// quindi viene utilizzata per gestire la cancellazione 
            	if (selected[0]===undefined) {	            		
            		if (description !== '') {
            			this.setState({
            				codArticle: '', 
                    description: '',
                    fuoriMisura: 0,
                    subGruppo: ''                                        
            			});
            		}
            		return;
            	}

            	// Binding tra option selezionata e i value del form
              let values = Object.values(selected[0]);           

             	this.setState({
            		codArticle: values[1],
                description: values[2],
                fuoriMisura: values[3],
                subGruppo: values[4]
            	});       
             
              let idPeso = this.askPesoRef.current.props.id;         
              let inputPeso = document.getElementById(idPeso);
              
              if (typeof inputPeso !== undefined) {    
                // Indica che l'articolo deve essere associato
                // a un valore di peso di persona             
                inputPeso.required = (values[4] == "M");                          
              }                            
            }}  	               
            
            onKeyDown={(e) => {  
              // Se key non è tab 
              if(e.keyCode !== 9) {                  
                if (description !== '') {
                  this.setState({
                    codArticle: '', 
                    description: '',
                    fuoriMisura: 0,
                    subGruppo: ''
                  });
                }
                return;
              }                            
            }}                                    	            
	        />
        </Col>
                
        <Col xs={12} lg={6}>        
          <label htmlFor={"descArt_"+pos} className="mt-2 mt-lg-0">Descrizione</label>
          <FormControl 
            id={"descArt_"+pos} name={"descArt_"+pos}
            type="text" value={description}
            data-caption={"Descrizione ("+pos+")"}    
            tabIndex="-1" readOnly
          />	                    
        </Col>

        <Col className="hiddenCol">
          <label htmlFor={"noteArt_"+pos} className="mt-2 mt-lg-0">Note aggiuntive</label>
          <FormControl 
            id={"noteArt_"+pos} name={"noteArt_"+pos}
            type="text"	maxLength="255" autoComplete="off"   
            data-caption={"Note aggiuntive ("+pos+")"} 
            data-parse="noteArt" defaultValue={this.state.note}              
          />		          
        </Col>        

        <Col xs={12} lg={2}>
          <label htmlFor={"pesoArt_"+pos} className="mt-2 mt-lg-0">Peso utilizzatore (kg)</label>
          <FormControl 
            id={"pesoArt_"+pos} name={"pesoArt_"+pos}
            pattern="^[0-9]+(\.[0-9]{1,2})?$" type="text" autoComplete="off"                       
            data-caption={"Peso ("+pos+")"} data-parse="number"            
            defaultValue={this.state.peso}
            ref={this.askPesoRef}                         
          />		          
        </Col>        

        <Col className='hiddenCol'>
          <label htmlFor={"subGruppo_"+pos} className="mt-2 mt-lg-0">SubGruppo</label>
          <FormControl 
            id={"subGruppo_"+pos} name={"subGruppo_"+pos}
            type="text"	maxLength="1" autoComplete="off"   
            data-caption={"SubGruppo ("+pos+")"} 
            data-parse="subGruppo" defaultValue={subGruppo}  
            readOnly   	            
          />		          
        </Col>

        <Col className='hiddenCol'>
          <label htmlFor={"dimArt_"+pos} className="mt-2 mt-lg-0">Dimensione</label>
          <FormControl 
            id={"dimArt_"+pos} name={"dimArt_"+pos}
            type="text"	maxLength="255" autoComplete="off"   
            data-caption={"Dimensione ("+pos+")"} 
            data-parse="dimArt" value={fuoriMisura}  
            readOnly   	            
          />		          
        </Col>        

        <Col xs={12} lg={1} className="noHorzPadding">
          <FormGroup>
          	<label htmlFor={"b_"+pos} className="mt-2 mt-lg-0">
              {pos+1}° prodotto</label>		            	
        		<Button 
        			className="btn-danger btn-outline" block
        			onClick={remove} name={"b_"+pos} id={"b_"+pos} 
              disabled={nrOfProducts===1 || this.props.disableBtns }>
              Elimina
            </Button>		            		              		            
          </FormGroup> 
        </Col>	
        <Col xs={12} lg={1}>
          <FormGroup>
            <label htmlFor={"b_"+pos} className="mt-2 mt-lg-0 colorWhite">
            {pos+1}°</label>                  
            <Button 
              className="btn-primary btn-outline" block
              onClick={this.handleLast} name={"b_"+pos} id={"b_"+pos} 
              disabled={this.props.disableBtns || this.props.editMode !== null}>
              Copia
            </Button>                                                 
          </FormGroup> 
        </Col>  
      </div>
    );
  }

  handleLast() {    
    this.props.handleLast([
      this.state.codArticle, 
      this.state.description, 
      this.state.note, 
      this.state.fuoriMisura,
      this.state.subGruppo,
      this.state.peso
    ]);
  }
}

export default Prodotto;


// WEBPACK FOOTER //
// ./src/cmp/Orders/Panels/PanelProdotti/Prodotto.js